import { Component, Pipe, PipeTransform } from '@angular/core';
import {Title} from '@angular/platform-browser';

import {UserService} from '../shared/user.service';
import {UserSettingsService} from '../shared/user-settings.service';
import {ApiService} from '../shared/api.service';
import {ViewService} from '../shared/view.service';

@Pipe({name: 'keyvalue', pure: false})
export class KeyValuePipe implements PipeTransform {
    transform(obj) {
        if( !obj  ) {
            return [];
        }
        return Object.values(obj);
    }
}
@Component({
    selector: 'menu-component',
    templateUrl: 'menu.component.html'
})
export class MenuComponent {
    options = [
        {
            title: 'My Queue',
            routerLink: ['/assignments', 'queue'],
            icon: 'assignment',
            limit: ['any'], // typescript issue with indexOf
            limited: false
        },
        {
            title: 'Create',
            routerLink: ['/assignment/create'],
            icon: 'mode_edit',
            limit: ['editor', 'administrator'],
            limited: false,
            submenu: [
                {
                    routerLink: ['/assignment/create'],
                    title: 'Slideshow'
                },
                {
                    routerLink: ['/assignment/create/quiz'],
                    title: 'Quiz'
                }
            ],

        },
        {
            title: 'Sent to Editor',
            routerLink: ['/assignments', 'sent-to-editor'],
            icon: 'send',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'Assigned',
            routerLink: ['/assignments', 'assigned'],
            icon: 'assignment_ind',
            limit: ['administrator', 'editor'],
            limited: false
        },
        {
            title: 'All Articles',
            routerLink: ['/assignments'],
            icon: 'view_list',
            limit: ['editor', 'dmc', 'administrator'], // typescript issue with indexOf
            limited: false
        },
        {
            title: 'Import',
            routerLink: ['/import'],
            icon: 'get_app',
            limit: ['editor', 'administrator'], // typescript issue with indexOf
            limited: true
        },
        {
            title: 'Users',
            routerLink: ['/users'],
            icon: 'person',
            limit: ['administrator', 'editor'],
            limited: false
        }
    ];
    user;
    constructor(private vs: ViewService, private titleService: Title,private userService: UserService, private userSettings: UserSettingsService, private api: ApiService) {
        const user = api.getProp('user');
        const limited = user.limited.length > 0;
        this.user = user;
        this.options = this.options.filter(option => {
            if( limited && option.limited ) {
                return false;
            }
            return option.limit.indexOf('any') !== -1 || option.limit.indexOf(user.role) !== -1;
        });
    }
    logout() {
        this.api.removeNonce();
        this.api.doAction('post', 'login', {
            logout: true
        }).subscribe(
            data => {
                this.userService.setCurrentUser(0);
            }
        );
    }
    setTitle(title) {
        this.titleService.setTitle('Swarm | ' + title);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/menu/menu.component.ts